import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { NAV_EXPERIMENT_ONBOARDING_KEYS } from '../../constants/onboarding-state/onboarding-constants.ts';

import onboardingStateGetOnboardingStateQuery, {
	type onboardingStateGetOnboardingStateQuery$data,
	type onboardingStateGetOnboardingStateQuery$variables,
} from './__generated_stale__/onboardingStateGetOnboardingStateQuery.graphql.ts';

type Result = { data: unknown; hasErrors: boolean };

export const preloadSideNavigationOnboardingState = (): Promise<Result> =>
	query<
		onboardingStateGetOnboardingStateQuery$data,
		onboardingStateGetOnboardingStateQuery$variables
	>({
		query: onboardingStateGetOnboardingStateQuery,
		variables: {
			key: [...NAV_EXPERIMENT_ONBOARDING_KEYS],
		},
	});
